import { useEffect, useState } from "react";
import EditIcon from "@mui/icons-material/Edit";
import { Typography, Grid, Box, Tab } from "@mui/material";
import { grey } from "@mui/material/colors";
import { useRecoilValue, useResetRecoilState, useSetRecoilState } from "recoil";
import ButtonCustom from "src/shared/components/buttons/ButtonCustom";
import { userState } from "src/store/user/userState";
import useSavePatient from "../hooks/useSavePatient";
import FormCompleteInformation from "../register/components/FormCompleteInformation";
import { valuesFormRegisterState } from "../state/atoms";
import useSEO from "src/Hooks/useSEO";
import { TabContext, TabPanel } from "@mui/lab";
import TabsCustom from "src/shared/components/tabs/TabsCustom";
import { useTheme } from "@emotion/react";
import FormResetPasswordProfile from "../recoveryPassword/components/FormResetPasswordProfile";
import useFamilyGroupLoader from "src/FamilyGroup/hooks/useFamilyGroupLoader";
import { FamilyView } from "src/FamilyGroup/components/FamilyView";
import { useParams } from "react-router-dom";
import { checkIsOwner } from "src/FamilyGroup/utils/ownerUtils";

const Index = () => {
  const user = useRecoilValue(userState);

  const activeAccount = checkIsOwner(user);
  const params = useParams();

  const setValuesFormRegister = useSetRecoilState(valuesFormRegisterState);
  const valuesFormRegister = useRecoilValue(valuesFormRegisterState);
  const resetValuesFormRegister = useResetRecoilState(valuesFormRegisterState);
  const { handleClickEditPatient, loading } = useSavePatient();

  const [activeTab, setActiveTab] = useState(0);
  const theme = useTheme();

  const handleChangeTab = (event, newValue) => {
    setActiveTab(newValue);
  };
  useSEO({ title: "Datos personales" });

  useEffect(() => {
    if (user.payload) {
      setValuesFormRegister({
        ...valuesFormRegister,
        ...user.payload,
        fechaNac: user.payload.fechaNac
          ? user.payload.fechaNac?.split(" ")[0].split("-").reverse().join("-")
          : null,
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  useEffect(() => {
    if (!activeAccount.haveAccount) {
      setActiveTab(2);
    }
    return () => {
      resetValuesFormRegister();
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { loadFamilyGroup } = useFamilyGroupLoader();

  useEffect(() => {
    if (activeTab === 2) {
      loadFamilyGroup();
    }
  }, [activeTab]);

  const sections = {
    "datos-personales": 0,
    seguridad: 1,
    "grupo-familiar": 2,
  };

  useEffect(() => {
    if (params.section) {
      setActiveTab(sections[params.section]);
    } else {
      setActiveTab(sections["datos-personales"]);
    }
  }, [params.section]);

  return (
    <Box sx={{ width: "100%" }}>
      <TabContext value={activeTab}>
        <Box sx={{ marginBottom: 2 }}>
          <TabsCustom
            theme={theme}
            onChange={handleChangeTab}
            aria-label="lab API tabs example"
          >
            {activeAccount.haveAccount && (
              <Tab label="Datos Personales" value={0} />
            )}
            {activeAccount.haveAccount && <Tab label="Seguridad" value={1} />}
            {/* <Tab label="Grupo Familiar" value={2} /> */}
          </TabsCustom>
        </Box>
        <TabPanel value={0} sx={{ p: 0 }}>
          {activeAccount.haveAccount && (
            <Box
              style={{
                backgroundColor: "#fff",
                padding: 10,
                borderRadius: 10,
              }}
            >
              <Typography
                color={grey[700]}
                fontWeight={700}
                fontSize={24}
                pt={2}
              >
                MODIFIQUE SUS DATOS PERSONALES
              </Typography>
              <Typography
                color={grey[400]}
                fontWeight={700}
                fontSize={12}
                pb={2}
              >
                INGRESE SUS DATOS
              </Typography>
              <FormCompleteInformation />

              <Grid
                container
                display={"flex"}
                justifyContent={"center"}
                p={2}
                pr={0}
              >
                <ButtonCustom
                  color="secondary"
                  loading={loading}
                  text="MODIFICAR DATOS"
                  icon={<EditIcon />}
                  onClick={handleClickEditPatient}
                />
              </Grid>
            </Box>
          )}
        </TabPanel>
        <TabPanel value={1} sx={{ p: 0 }}>
          {activeAccount.haveAccount && (
            <Box
              style={{
                backgroundColor: "#fff",
                padding: 10,
                borderRadius: 10,
              }}
            >
              <Typography
                color={grey[700]}
                fontWeight={700}
                fontSize={24}
                pt={2}
              >
                CAMBIE SU CONTRASEÑA
              </Typography>
              <Typography
                color={grey[400]}
                fontWeight={700}
                fontSize={12}
                pb={2}
              >
                INGRESE SU NUEVA CONTRASEÑA
              </Typography>
              <FormResetPasswordProfile />
            </Box>
          )}
        </TabPanel>
        <TabPanel value={2} sx={{ p: 0 }}>
          <FamilyView />
        </TabPanel>
      </TabContext>
    </Box>
  );
};

export default Index;
